module.exports = __webpack_public_path__ + "static/media/PS-11.665e4bb0.svg";